module.exports = __webpack_public_path__ + "media/assets/icons/download-f8cab05bd219c5c4b7249537cc475a61.svg";